import React, { useEffect, useRef, useState } from 'react';
import "./pricing.css";
import { FaCircleXmark, FaRotate, FaTurkishLiraSign } from 'react-icons/fa6';
import { FaCheckCircle, FaStar } from 'react-icons/fa';
import ReactFlipCard from 'reactjs-flip-card';
import { useLanguage } from '../../context/LanguageContext';

const Pricing = () => {
    const { t, changeLanguage } = useLanguage();
    const PackageItems = [
        {
            id: 1,
            range: "monthly",
            title: t("package1-title"),
            price: t("package1-text"),
            oldPrice: "",
            advantages: t("package1-advantages", { returnObjects: true }),
            disadvantages: t("package1-disadvantages", { returnObjects: true }),
            link: "/signup"
        },
        {
            id: 2,
            range: "monthly",
            title: t("package2-title"),
            price: t("package2-text"),
            oldPrice: "",
            advantages: t("package2-advantages", { returnObjects: true }),
            disadvantages: t("package2-disadvantages", { returnObjects: true }),
            link: "/signup"
        },
        {
            id: 3,
            range: "monthly",
            title: t("package3-title"),
            price: t("package3-text"),
            oldPrice: "",
            advantages: t("package3-advantages", { returnObjects: true }),
            disadvantages: t("package3-disadvantages", { returnObjects: true }),
            link: "/signup"
        },
        {
            id: 4,
            range: "yearly",
            title: "Başlangıç Paket",
            price: "Ücretsiz",
            oldPrice: "Ücretsiz",
            advantages: ["Ücretsiz bir şekilde modeli test etme imkanı.", "Günlük 10 adet ücretsiz istekte bulunma imkanı."],
            disadvantages: ["Günlük istek limiti.", "Bir istekte maksimum karakter sınırı (400 karakter).", "Yalnızca metin bazlı istekler."],
            link: "/signup"
        },
        {
            id: 5,
            range: "yearly",
            title: "Premium Paket",
            price: "149",
            oldPrice: "199",
            advantages: ["Günlük 1000 istekte bulunma imkanı", "Görsel içerikli mesaj ile istek oluşturmak.", "Daha hızlı geri dönüş alma imkanı."],
            disadvantages: ["Bir istekte maksimum karakter sınırı (1000 karakter).", "Görsel içerikli mesajlarda dosya boyutu sınırı (5 MB)."],
            link: "/signup"
        },
        {
            id: 6,
            range: "yearly",
            title: "Deluxe Paket",
            price: "399",
            oldPrice: "499",
            advantages: ["Günlük sınırsız istek oluşturma imkanı.", "15 Bin karaktere kadar istekte bulunma imkanı.", "Büyük boyutlu dosya yükleme imkanı (50 MB).", "Daha hızlı geri dönüş alma imkanı."],
            disadvantages: [],
            link: "/signup"
        },
    ];

    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef();

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.unobserve(entry.target);
            }
        });
    });

    useEffect(() => {
        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [ref]);


    const monthlyItems = PackageItems.filter(item => item.range === 'monthly');
    const yearlyItems = PackageItems.filter(item => item.range === 'yearly');

    return (
        <div className={`pricing-container text-left ${isVisible ? 'fade-in' : ''}`} ref={ref} id='pricing-container-div'>
            <div className='md:flex justify-between items-center'>
                <div className='flex pricing-header'>
                    <span className='pricing-head-title'>{t("pricing-headtitle")}</span>
                    <hr className='homepage-hr' />
                </div>
            </div>

            <div className='mt-4'>
                <ul class="nav nav-underline" id="priceRangeTab" role="tablist">
                    {/* <li class="nav-item" role="presentation">
                        <button class="nav-link active price-range-nav-link" id="monthly-tab" data-bs-toggle="tab" data-bs-target="#monthly-tab-pane" type="button" role="tab" aria-controls="monthly-tab-pane" aria-selected="true">Aylık</button>
                    </li> */}
                    {/* <li class="nav-item" role="presentation">
                        <button class="nav-link price-range-nav-link" id="yearly-tab" data-bs-toggle="tab" data-bs-target="#yearly-tab-pane" type="button" role="tab" aria-controls="yearly-tab-pane" aria-selected="false">Yıllık</button>
                    </li> */}

                </ul>
                <div class="tab-content" id="priceRangeTabContent">
                    <div class="tab-pane fade show active" id="monthly-tab-pane" role="tabpanel" aria-labelledby="monthly-tab" tabindex="0">
                        <div className='pricing-card-container md:grid grid-cols-3 gap-4 mt-4'>
                            {monthlyItems.map((item) => (
                                // <div className='pricing-card-item' key={item.id}>
                                //     <h2 className='pricing-card-title1'>{item.title}</h2>
                                //     <h3 className='pricing-card-number'>
                                //         {item.price === "Ücretsiz" ? (
                                //             item.price
                                //         ) : (
                                //             <>
                                //                 <FaTurkishLiraSign className='text-3xl' /> {item.price}
                                //             </>
                                //         )}
                                //     </h3>
                                //     <hr className='my-4' />
                                //     <div className='advantages-list'>
                                //         {item.advantages.map((advantage, index) => (
                                //             <div className='grid grid-cols-8 items-start' key={index}>
                                //                 <div className='col-span-1'><FaCheckCircle className='price-card-icon' /></div>
                                //                 <div className='col-span-7'>{advantage}</div>
                                //             </div>
                                //         ))}
                                //         {item.disadvantages.map((disadvantage, index) => (
                                //             <div className='grid grid-cols-8 items-start' key={index}>
                                //                 <div className='col-span-1'><FaCircleXmark className='price-card-icon2' /></div>
                                //                 <div className='col-span-7'>{disadvantage}</div>
                                //             </div>
                                //         ))}
                                //     </div>
                                //     <button className='navbar-try-link mt-8'>Abone Ol</button>
                                // </div>
                                <ReactFlipCard

                                    frontComponent={<div>
                                        <div className='pricing-card-item pricing-card-item-front' key={item.id}>
                                            <div>
                                                <h2 className='pricing-card-title1'>{item.title}</h2>
                                                <h3 className='pricing-card-number'>
                                                    {item.price === "Ücretsiz" ? (
                                                        item.price
                                                    ) : (
                                                        <>
                                                            {/* <FaTurkishLiraSign className='text-3xl' />  */}
                                                            {item.price}
                                                        </>
                                                    )}
                                                </h3>
                                                {/* <hr className='my-4' /> */}
                                                <FaRotate className='pricing-rotate-icon' /></div>
                                            <div className='flex gap-2 items-center '><FaStar /> {t("pricing-info")}</div>
                                        </div>
                                    </div>}
                                    backComponent={<div>
                                        <div className='pricing-card-item' key={item.id}>
                                            <div className='advantages-list'>
                                                {item.advantages.map((advantage, index) => (
                                                    <div className='grid grid-cols-8 items-start' key={index}>
                                                        <div className='col-span-1'><FaCheckCircle className='price-card-icon' /></div>
                                                        <div className='col-span-7'>{advantage}</div>
                                                    </div>
                                                ))}
                                                {item.disadvantages.map((disadvantage, index) => (
                                                    <div className='grid grid-cols-8 items-start' key={index}>
                                                        <div className='col-span-1'><FaCircleXmark className='price-card-icon2' /></div>
                                                        <div className='col-span-7'>{disadvantage}</div>
                                                    </div>
                                                ))}
                                            </div>
                                            {/* <button className='navbar-try-link mt-8'>Abone Ol</button> */}

                                        </div>
                                    </div>} />
                            ))}
                        </div>
                    </div>
                    <div class="tab-pane fade" id="yearly-tab-pane" role="tabpanel" aria-labelledby="yearly-tab" tabindex="0">
                        <div className='pricing-card-container md:grid grid-cols-3 gap-4 mt-4'>
                            {yearlyItems.map((item) => (
                                // <div className='pricing-card-item' key={item.id}>
                                //     <h2 className='pricing-card-title1'>{item.title}</h2>
                                //     <h3 className='pricing-card-number'>
                                //         {item.price === "Ücretsiz" ? (
                                //             item.price
                                //         ) : (
                                //             <>
                                //                 <FaTurkishLiraSign className='text-3xl' /> {item.price}
                                //             </>
                                //         )}
                                //         {item.oldPrice === "Ücretsiz" ? (
                                //             " "
                                //         ) : (
                                //             <span className='text-xl ml-2'>/ Aylık</span>
                                //         )}
                                //         {item.oldPrice === "Ücretsiz" ? (
                                //             " "
                                //         ) : (
                                //             <span className='pricing-old-price'><FaTurkishLiraSign className='text-xl' />{item.oldPrice}</span>
                                //         )}


                                //     </h3>

                                //     <hr className='my-4' />
                                //     <div className='advantages-list'>
                                //         {item.advantages.map((advantage, index) => (
                                //             <div className='grid grid-cols-8 items-start' key={index}>
                                //                 <div className='col-span-1'><FaCheckCircle className='price-card-icon' /></div>
                                //                 <div className='col-span-7'>{advantage}</div>
                                //             </div>
                                //         ))}
                                //         {item.disadvantages.map((disadvantage, index) => (
                                //             <div className='grid grid-cols-8 items-start' key={index}>
                                //                 <div className='col-span-1'><FaCircleXmark className='price-card-icon2' /></div>
                                //                 <div className='col-span-7'>{disadvantage}</div>
                                //             </div>
                                //         ))}
                                //     </div>
                                //     <button className='navbar-try-link mt-8'>Abone Ol</button>
                                // </div>
                                <ReactFlipCard
                                    frontComponent={<div>
                                        <div className='pricing-card-item' key={item.id}>
                                            <h2 className='pricing-card-title1'>{item.title}</h2>
                                            <h3 className='pricing-card-number'>
                                                {item.price === "Ücretsiz" ? (
                                                    item.price
                                                ) : (
                                                    <>
                                                        <FaTurkishLiraSign className='text-3xl' /> {item.price}
                                                    </>
                                                )}
                                                {item.oldPrice === "Ücretsiz" ? (
                                                    " "
                                                ) : (
                                                    <span className='text-xl ml-2'>/ Aylık</span>
                                                )}
                                                {item.oldPrice === "Ücretsiz" ? (
                                                    " "
                                                ) : (
                                                    <span className='pricing-old-price'><FaTurkishLiraSign className='text-xl' />{item.oldPrice}</span>
                                                )}


                                            </h3>
                                            <FaRotate className='pricing-rotate-icon' />
                                        </div>
                                    </div>}
                                    backComponent={<div>
                                        <div className='pricing-card-item' key={item.id}>
                                            <div className='advantages-list'>
                                                {item.advantages.map((advantage, index) => (
                                                    <div className='grid grid-cols-8 items-start' key={index}>
                                                        <div className='col-span-1'><FaCheckCircle className='price-card-icon' /></div>
                                                        <div className='col-span-7'>{advantage}</div>
                                                    </div>
                                                ))}
                                                {item.disadvantages.map((disadvantage, index) => (
                                                    <div className='grid grid-cols-8 items-start' key={index}>
                                                        <div className='col-span-1'><FaCircleXmark className='price-card-icon2' /></div>
                                                        <div className='col-span-7'>{disadvantage}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>} />
                            ))}
                        </div>
                    </div>
                </div>
                <div className='text-center mt-16'>

                    <a className='navbar-try-link' href="/contact" >{t("pricing-info2")}</a>

                </div>
            </div>
        </div>
    );
};

export default Pricing;
